import api from "./api";

export const getCustomers = (userId, page, size) => {
  return api.get(`/customers?userId=${userId}&page=${page}&size=${size}`);
};

export const createCustomer = (customer) => {
  return api.post("/customers", customer);
};

export const updateCustomer = (id, customer) => {
  return api.put(`/customers/${id}`, customer);
};

export const deleteCustomer = (id, adminId) => {
  return api.delete(`/customers/${id}?adminId=${adminId}`);
};

export const loginCustomer = (customerLoginRequest) => {
  return api.post("/customers/login", customerLoginRequest);
};

export const updateCustomerPassword = async (customerId, passwordData) => {
  return api.put(`/customers/password/${customerId}`, passwordData);
};

export const updateCustomerBillingInfo = (customerId, data) => {
  return api.put(`/customers/${customerId}/billing-info`, data);
};

// For Dropdowns
export const getAllCustomers = async (userId, maxResults = 100) => {
  // This function will fetch multiple pages as needed up to maxResults
  let allCustomers = [];
  let currentPage = 0;
  const pageSize = 50; // Fetch more per request for efficiency

  try {
    let hasMoreData = true;

    while (hasMoreData && allCustomers.length < maxResults) {
      const response = await getCustomers(userId, currentPage, pageSize);
      const customers = response.data.content || [];

      if (customers.length === 0) {
        hasMoreData = false;
      } else {
        const mappedCustomers = customers.map(customer => ({
          id: customer.id,
          name: customer.companyName,
          email: customer.email,
          phone: customer.phone,
          contactPerson: customer.contactPerson
        }));

        allCustomers = [...allCustomers, ...mappedCustomers];
        currentPage++;
      }

      // Check if we've reached the last page
      if (response.data.last) {
        hasMoreData = false;
      }
    }

    return allCustomers.slice(0, maxResults);
  } catch (error) {
    console.error("Error fetching all customers:", error);
    return [];
  }
};
